module.exports = __webpack_public_path__ + "static/img/caboArduino-1.efd751d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/caboArduino-1.svg
// module id = zidy
// module chunks = 0